var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeRewards2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 186.58 199.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-rw2{fill:#ff3b83;}.cls-2-rw2{fill:#ffc300;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icone_Resume_new",
    "data-name": "Icone Resume new"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_3",
    "data-name": "Livello 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-rw2",
    d: "M96.67,143.42H90v-6.16a14.21,14.21,0,0,0-14.19-14.2H51a51,51,0,0,1-51-51V54.63A54.7,54.7,0,0,1,54.63,0h5.31a36.64,36.64,0,0,1,36.6,36.6V60.34H89.91V36.6a30,30,0,0,0-30-30H54.63a48.05,48.05,0,0,0-48,48V72.08A44.41,44.41,0,0,0,51,116.43H75.85a20.85,20.85,0,0,1,20.82,20.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-rw2",
    d: "M140.64,199.18H113.45A23.49,23.49,0,0,1,90,175.71V165H23.14v-6.63H90v-5.77h6.63v5.77h44a20.42,20.42,0,1,1,0,40.84ZM96.61,165v10.74a16.85,16.85,0,0,0,16.84,16.84h27.19a13.79,13.79,0,1,0,0-27.58Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2-rw2",
    points: "96.54 49.53 89.05 49.53 89.05 42.9 89.91 42.9 89.91 39.58 96.54 39.58 96.54 49.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-rw2",
    d: "M96.54,62.59H84.94a9.85,9.85,0,1,1,0-19.69h11.6ZM84.94,49.53a3.22,3.22,0,1,0,0,6.43h5V49.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-rw2",
    d: "M89.91,137.79a21,21,0,0,1,20.82-21.36H135.6A44.41,44.41,0,0,0,180,72.08V54.63a48.05,48.05,0,0,0-48-48h-5.31a30,30,0,0,0-30,30V60.34H90V36.6A36.64,36.64,0,0,1,126.64,0H132a54.7,54.7,0,0,1,54.63,54.63V72.08a51,51,0,0,1-51,51H110.73a14.21,14.21,0,0,0-14.19,14.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-rw2",
    d: "M101.65,62.59H90V42.9h11.61a9.85,9.85,0,1,1,0,19.69Zm-5-6.63h5a3.28,3.28,0,0,0,3.24-3.24,3.24,3.24,0,0,0-3.24-3.19h-5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-rw2",
    x: 9.75,
    y: 158.27,
    width: 13.39,
    height: 6.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-rw2",
    x: 0.06,
    y: 158.4,
    width: 5.83,
    height: 6.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-rw2",
    x: 86.86,
    y: 137.05,
    width: 12.87,
    height: 21.28
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2-rw2",
    points: "97.54 49.53 90.04 49.53 90.04 39.58 96.67 39.58 96.67 42.9 97.54 42.9 97.54 49.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-rw2",
    d: "M141.5,199.12a19.56,19.56,0,1,1,19.56-19.56A19.58,19.58,0,0,1,141.5,199.12Zm0-32.49a12.93,12.93,0,1,0,12.93,12.93A12.94,12.94,0,0,0,141.5,166.63Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeRewards2);
export default __webpack_public_path__ + "static/media/home-rewards-2.0014cd00143a006610ced56b396cb911.svg";
export { ForwardRef as ReactComponent };